import { createContext } from "react";
import { IDocumentMediaPreviewData } from "@home-health-notify/domain";

export interface IDocumentMediaViewerContext {
  openDocumentMediaViewer: (
    message: IDocumentMediaPreviewData,
    mediaList?: IDocumentMediaPreviewData[],
    onDocumentMediaDialogClose?: () => void,
  ) => void;
  message?: IDocumentMediaPreviewData;
  mediaList?: IDocumentMediaPreviewData[];
  onDocumentMediaDialogClose?: () => void;
}

export const DocumentMediaViewerContext =
  createContext<IDocumentMediaViewerContext>({} as IDocumentMediaViewerContext);
